// extracted by mini-css-extract-plugin
module.exports = {"title":"HomeTitle_title__1MHdE","fundedText":"HomeTitle_fundedText__pfq4s","build":"HomeTitle_build__22jSU","jpTitle":"HomeTitle_jpTitle__9ZT89"};